import { ErrorHandler, Injectable, Injector } from '@angular/core';
import { LoggingService } from '../services/logging.service';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  private logService: LoggingService;

  constructor(injector: Injector) {
    this.logService = injector.get(LoggingService);
  }

  handleError(error) {
    console.error(error);
    this.logService.logMessage(4, error.message, error.stack);
  }
}
